import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/brand/Logo";

const links = [
  { id: "services", label: "Services" },
  { id: "framework", label: "POP\u2122" },
  { id: "lead-magnet", label: "Sample Brief" },
  { id: "audience", label: "Who We Help" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 70,
        behavior: "smooth",
      });
    }
    setOpen(false);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F3EFE7]/92 backdrop-blur-md border-b border-[#2A2422]/8"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          className="flex items-center"
          data-testid="nav-logo"
          aria-label="BOOMM Group home"
        >
          <Logo compact />
        </button>

        <nav className="hidden md:flex items-center gap-7" aria-label="Primary">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="font-body text-[0.84rem] tracking-wide text-[#2A2422]/80 hover:text-[#B58B42] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center">
          <button
            onClick={() => scrollTo("contact")}
            data-testid="nav-cta"
            className="btn-primary px-5 py-2.5 text-[0.85rem] font-medium tracking-wide rounded-[2px]"
          >
            Spark Better Decisions
          </button>
        </div>

        <button
          className="md:hidden p-2 -mr-2 text-[#2A2422]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden bg-[#F3EFE7] border-t border-[#2A2422]/10"
          data-testid="nav-mobile-panel"
        >
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-mobile-link-${l.id}`}
              className="mobile-nav-link w-full text-left"
            >
              {l.label}
            </button>
          ))}
          <div className="px-6 py-4">
            <button
              onClick={() => scrollTo("contact")}
              className="btn-primary w-full px-5 py-3 text-sm tracking-wide rounded-[2px]"
              data-testid="nav-mobile-cta"
            >
              Spark Better Decisions
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
